import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

router.beforeEach(async (to, from, next) => {
  NProgress.start() // 开启nprogress
  if (store.state.userInfo.id || to.path === '/login') {
    next()
  } else {
    try {
      await store.dispatch('getUserInfo')
      next()
    } catch (err) {
      next({ path: '/login' })
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 关闭nprogress
})
